import React from 'react';
import { usePublicLanguage } from '../contexts/PublicLanguageContext';
import { emphasize } from '../utils/emphasize';
import './TermsOfService.css';

const TermsOfService: React.FC = () => {
  const { t } = usePublicLanguage();
  const s = t.terms;

  return (
    <div className="terms-container">
      {/* Header Section */}
      <section className="terms-header">
        <div className="terms-header-content">
          <img src="/logo192.png" alt="Yarnboard" className="terms-logo" style={{ width: 56, height: 56, borderRadius: 12, objectFit: 'cover' }} />
          <h1>{s.title}</h1>
          <p className="terms-tagline">{s.tagline}</p>
        </div>
      </section>

      {/* Terms Content */}
      <section className="terms-content-section">
        <div className="terms-content">
          <p className="terms-effective">
            <strong>{s.effectiveDate}</strong> {s.effectiveDateValue}<br />
            <strong>{s.lastUpdated}</strong> {s.lastUpdatedValue}
          </p>

          <div className="terms-intro">
            <p>{s.intro}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.acceptance}</h2>
            <p>{s.acceptanceIntro}</p>
            <ul>
              <li>{s.acceptance1}</li>
              <li>{s.acceptance2}</li>
              <li>{s.acceptance3}</li>
              <li>{s.acceptance4}</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>{s.sections.description}</h2>
            <p>{s.descriptionIntro}</p>
            <ul>
              <li>{s.description1}</li>
              <li>{s.description2}</li>
              <li>{s.description3}</li>
              <li>{s.description4}</li>
              <li>{s.description5}</li>
              <li>{s.description6}</li>
            </ul>
            <p>{s.descriptionOutro}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.accounts}</h2>

            <h3>{s.accountsCreationTitle}</h3>
            <p>{s.accountsCreationIntro}</p>
            <ul>
              <li>{s.accountsCreation1}</li>
              <li>{s.accountsCreation2}</li>
              <li>{s.accountsCreation3}</li>
              <li>{s.accountsCreation4}</li>
              <li>{s.accountsCreation5}</li>
            </ul>

            <h3>{s.accountsTerminationTitle}</h3>
            <p>{s.accountsTerminationBody}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.content}</h2>

            <h3>{s.contentYoursTitle}</h3>
            <p>{s.contentYoursIntro}</p>
            <ul>
              <li>{s.contentYours1}</li>
              <li>{s.contentYours2}</li>
              <li>{s.contentYours3}</li>
            </ul>
            <p>{s.contentYoursOutro}</p>

            <h3>{s.contentResponsibilityTitle}</h3>
            <p>{s.contentResponsibilityIntro}</p>
            <ul>
              <li>{s.contentResponsibility1}</li>
              <li>{s.contentResponsibility2}</li>
              <li>{s.contentResponsibility3}</li>
            </ul>

            <h3>{s.contentProhibitedTitle}</h3>
            <p>{s.contentProhibitedIntro}</p>
            <ul>
              <li>{s.contentProhibited1}</li>
              <li>{s.contentProhibited2}</li>
              <li>{s.contentProhibited3}</li>
              <li>{s.contentProhibited4}</li>
              <li>{s.contentProhibited5}</li>
              <li>{s.contentProhibited6}</li>
              <li>{s.contentProhibited7}</li>
            </ul>

            <h3>{s.contentOurRightsTitle}</h3>
            <p>{s.contentOurRightsBody}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.acceptableUse}</h2>
            <p>{s.acceptableUseIntro}</p>
            <ul>
              <li>{s.acceptableUse1}</li>
              <li>{s.acceptableUse2}</li>
              <li>{s.acceptableUse3}</li>
              <li>{s.acceptableUse4}</li>
              <li>{s.acceptableUse5}</li>
              <li>{s.acceptableUse6}</li>
              <li>{s.acceptableUse7}</li>
              <li>{s.acceptableUse8}</li>
              <li>{s.acceptableUse9}</li>
              <li>{s.acceptableUse10}</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>{s.sections.payment}</h2>

            <h3>{s.paymentPricingTitle}</h3>
            <p>{s.paymentPricingBody}</p>

            <h3>{s.paymentBillingTitle}</h3>
            <p>{s.paymentBillingIntro}</p>
            <ul>
              <li>{s.paymentBilling1}</li>
              <li>{s.paymentBilling2}</li>
              <li>{s.paymentBilling3}</li>
              <li>{s.paymentBilling4}</li>
            </ul>

            <h3>{s.paymentCancellationTitle}</h3>
            <p>{s.paymentCancellationBody}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.privacy}</h2>
            <p>{s.privacyBody}</p>
            <p>{emphasize(s.privacyGdpr)}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.disclaimers}</h2>

            <h3>{s.disclaimersAsIsTitle}</h3>
            <p>{s.disclaimersAsIsBody}</p>
            <p>{s.disclaimersNoWarrantyIntro}</p>
            <ul>
              <li>{s.disclaimersNoWarranty1}</li>
              <li>{s.disclaimersNoWarranty2}</li>
              <li>{s.disclaimersNoWarranty3}</li>
              <li>{s.disclaimersNoWarranty4}</li>
            </ul>

            <h3>{s.disclaimersLiabilityTitle}</h3>
            <p>{s.disclaimersLiabilityP1}</p>
            <p>{s.disclaimersLiabilityP2}</p>

            <h3>{s.disclaimersBackupTitle}</h3>
            <p>{s.disclaimersBackupBody}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.indemnification}</h2>
            <p>{s.indemnificationIntro}</p>
            <ul>
              <li>{s.indemnification1}</li>
              <li>{s.indemnification2}</li>
              <li>{s.indemnification3}</li>
              <li>{s.indemnification4}</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>{s.sections.thirdParty}</h2>
            <p>{s.thirdPartyBody}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.copyright}</h2>
            <p>{s.copyrightIntro}</p>
            <ul>
              <li>{s.copyright1}</li>
              <li>{s.copyright2}</li>
              <li>{s.copyright3}</li>
              <li>{s.copyright4}</li>
              <li>{s.copyright5}</li>
              <li>{s.copyright6}</li>
            </ul>
            <p>{s.copyrightOutro}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.disputes}</h2>

            <h3>{s.disputesInformalTitle}</h3>
            <p>{s.disputesInformalBody}</p>

            <h3>{s.disputesArbitrationTitle}</h3>
            <p>{s.disputesArbitrationBody}</p>

            <h3>{s.disputesEuTitle}</h3>
            <p>{s.disputesEuBody}</p>

            <h3>{s.disputesClassActionTitle}</h3>
            <p>{s.disputesClassActionBody}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.governing}</h2>
            <p>{s.governingBody}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.modifications}</h2>
            <p>{s.modificationsP1}</p>
            <p>{s.modificationsP2}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.severability}</h2>
            <p>{s.severabilityBody}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.entire}</h2>
            <p>{s.entireBody}</p>
          </div>

          <div className="terms-section">
            <h2>{s.sections.contact}</h2>
            <p>{s.contactIntro}</p>
            <ul>
              <li>{emphasize(s.contactEmail)}</li>
              <li>{emphasize(s.contactSupport)}</li>
              <li>{emphasize(s.contactLocation)}</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>{s.sections.euProvisions}</h2>
            <p>{s.euIntro}</p>
            <ul>
              <li>{emphasize(s.euWithdrawal)}</li>
              <li>{emphasize(s.euGuarantees)}</li>
              <li>{emphasize(s.euUnfair)}</li>
              <li>{emphasize(s.euDataProtection)}</li>
            </ul>
          </div>

          <div className="terms-acknowledgment">
            <p>
              <strong>{s.acknowledgment}</strong>
            </p>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <section className="terms-footer">
        <div className="terms-content">
          <p>{t.footer.madeWith}</p>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
